export default __webpack_public_path__ + "static/dag-logo-with-text-xl-ab2d56698a227a3140f41f12219fa368.png";